"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var noop = function noop() {};

var enterKeyCode = 13;
var escKeyCode = 27;

var isTextTruthy = function isTextTruthy(val) {
  return val !== undefined && val !== null && val.toString() !== '';
};

var sizeStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  visibility: 'hidden',
  height: 0,
  overflow: 'scroll',
  whiteSpace: 'pre'
};
var sizeClasses = {
  "default": '',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  small: 'small'
};

var InlineEdit = function InlineEdit(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      forwardedRef = _ref.forwardedRef,
      id = _ref.id,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 130 : _ref$minWidth,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      placeholder = _ref.placeholder,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$requiredWarningM = _ref.requiredWarningMessage,
      requiredWarningMessage = _ref$requiredWarningM === void 0 ? 'This Field is Required' : _ref$requiredWarningM,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$validateInput = _ref.validateInput,
      validateInput = _ref$validateInput === void 0 ? noop : _ref$validateInput,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
      _ref$onCancel = _ref.onCancel,
      onCancel = _ref$onCancel === void 0 ? noop : _ref$onCancel,
      onChange = _ref.onChange,
      _ref$onEditStateChang = _ref.onEditStateChange,
      onEditStateChange = _ref$onEditStateChang === void 0 ? noop : _ref$onEditStateChang,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
      onSave = _ref.onSave,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["disabled", "forwardedRef", "id", "label", "minWidth", "name", "placeholder", "required", "requiredWarningMessage", "size", "type", "validateInput", "value", "onBlur", "onCancel", "onChange", "onEditStateChange", "onFocus", "onSave"]); // States for Inline Edit

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showInput = _useState4[0],
      setShowInput = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      inputWidth = _useState6[0],
      setInputWidth = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      savedTimer = _useState8[0],
      setSavedTimer = _useState8[1];

  var _useState9 = (0, _react.useState)(['resting-text']),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      restingClassNames = _useState10[0],
      setRestingClassNames = _useState10[1];

  var _useState11 = (0, _react.useState)(),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      validationError = _useState12[0],
      setValidationError = _useState12[1];

  var inputId = (0, _utils.useMemoizedId)({
    id: id,
    label: label
  }); // ensure we clear any timers in case component unmounts.

  (0, _react.useEffect)(function () {
    return function () {
      return clearTimeout(savedTimer);
    };
  }, [savedTimer]);
  (0, _react.useEffect)(function () {
    onEditStateChange(showInput);
  }, [showInput, onEditStateChange]);
  (0, _react.useEffect)(function () {
    if (value) {
      setLocalValue(value);
    }
  }, [value]);
  (0, _react.useEffect)(function () {
    setValidationError(validateInput(localValue));
  }, [localValue, validateInput]);
  var hasOnChange = Boolean(onChange);
  var displayValue = hasOnChange ? value : localValue;
  (0, _react.useEffect)(function () {
    if (!isTextTruthy(displayValue) && required) {
      setValidationError(requiredWarningMessage);
    }
  }, [displayValue, required, requiredWarningMessage]);
  var inputRef = (0, _react.useRef)();
  /**
   * This hook is used to customize the instance value exposed to the parent for the ref.
   * It must always be used with React.forwardRef. This gives us control of where to pass the ref prop.
   * Whatever ref is passed to Inline Edit will receive the inputRef instance.
   * This pattern supports all methods of creating refs.
   */

  (0, _react.useImperativeHandle)(forwardedRef, function () {
    return inputRef.current;
  }); // used to calculate sizing for input to grow with text

  var valueSizeRef = (0, _react.useRef)();
  var placeholderSizeRef = (0, _react.useRef)();
  var errorMessageRef = (0, _react.useRef)();
  var isTextArea = type === 'textarea';
  (0, _react.useEffect)(function () {
    var extraPadding = 70;
    var pencilPadding = 25;
    var newWidth = isTextTruthy(displayValue) ? valueSizeRef.current.scrollWidth : placeholderSizeRef.current ? placeholderSizeRef.current.scrollWidth : 0;
    var errorMessageWidth = errorMessageRef.current ? errorMessageRef.current.scrollWidth : 0;
    newWidth = Math.max(newWidth, errorMessageWidth);
    newWidth += showInput ? extraPadding : pencilPadding;

    if (newWidth < minWidth) {
      newWidth = minWidth;
    }

    setInputWidth(newWidth);
  }, [displayValue, valueSizeRef, placeholderSizeRef, minWidth, showInput, validationError]);
  (0, _react.useEffect)(function () {
    if (showInput && isTextArea) {
      // Set the cursor to the end of the text and scroll to the end
      inputRef.current.setSelectionRange(inputRef.current.textContent.length, inputRef.current.textContent.length);
      inputRef.current.scrollTop = inputRef.current.scrollHeight;
    }
  }, [isTextArea, showInput]);

  var showSuccess = function showSuccess() {
    setRestingClassNames([].concat((0, _toConsumableArray2["default"])(restingClassNames), ['saved']));
    setShowInput(false);
    setSavedTimer(setTimeout(function () {
      return setRestingClassNames(restingClassNames.filter(function (className) {
        return className !== 'saved';
      }));
    }, 1000));
  };

  var handleBlur = function handleBlur(e) {
    if (hasOnChange) {
      setShowInput(false);
      showSuccess();
    }

    onBlur(e);
  };

  var handleFocus = function handleFocus(e) {
    onFocus(e);
  };

  var handleChange = function handleChange(e) {
    var inputValue = e.target.value;

    if (hasOnChange) {
      onChange(e);
    } else {
      setLocalValue(inputValue);
    }
  };

  var handleSaveClick = function handleSaveClick(e) {
    if (!hasOnChange) {
      if (validationError) {
        return;
      }

      onSave({
        value: localValue,
        name: name
      }, e);
    }

    showSuccess();
  }; // Optional to handle how we cancel our input


  var handleCancelClick = function handleCancelClick(e) {
    onCancel({
      value: localValue,
      name: name
    }, e);
    setLocalValue(value);
    setShowInput(false);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === enterKeyCode) {
      handleSaveClick();
    } else if (e.keyCode === escKeyCode) {
      handleCancelClick();
    }
  };

  var handleActiveClick = function handleActiveClick() {
    setShowInput(true);
  };

  var inputProps = _objectSpread({}, rest, {
    name: name,
    type: type,
    value: displayValue,
    label: label,
    placeholder: placeholder,
    id: inputId,
    onKeyDown: handleKeyDown,
    ref: inputRef,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: handleChange,
    autoFocus: true
  });

  var inputStyle = {
    marginBottom: '20px',
    width: showInput ? "".concat(inputWidth, "px") : null
  };
  var className = (0, _emotion.cx)('inline-edit-group', {
    required: required
  });

  var inlineInput = _react["default"].createElement(_react["default"].Fragment, null, isTextArea ? _react["default"].createElement("textarea", (0, _extends2["default"])({
    className: (0, _emotion.cx)(sizeClasses[size], 'form-control')
  }, inputProps, {
    style: {
      marginTop: '17px',
      padding: '16px',
      minWidth: '100px'
    }
  })) : _react["default"].createElement("input", (0, _extends2["default"])({
    className: sizeClasses[size]
  }, inputProps)), label ? _react["default"].createElement("label", {
    className: (0, _emotion.cx)('control-label', {
      'textarea-label': isTextArea
    }),
    htmlFor: inputId
  }, label) : null, !hasOnChange ? _react["default"].createElement("div", {
    className: "right-addon"
  }, _react["default"].createElement("button", {
    onClick: handleSaveClick,
    "aria-label": "save",
    disabled: Boolean(validationError)
  }, _react["default"].createElement("i", {
    className: "fa fa-check"
  })), _react["default"].createElement("button", {
    onClick: handleCancelClick,
    "aria-label": "cancel"
  }, _react["default"].createElement("i", {
    className: "fa fa-times"
  }))) : null); // For disabled state we add the disabled class to the parent
  // In addition we pass a <p> without the onClick handler


  var inlineDisplay = _react["default"].createElement("span", {
    className: _emotion.cx.apply(void 0, (0, _toConsumableArray2["default"])(restingClassNames).concat([{
      disabled: disabled
    }]))
  }, disabled ? _react["default"].createElement("p", {
    className: sizeClasses[size]
  }, displayValue || placeholder) : _react["default"].createElement("p", {
    className: sizeClasses[size],
    onClick: handleActiveClick
  }, displayValue || placeholder), label ? _react["default"].createElement("div", {
    className: "resting-label"
  }, label) : null);

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: className,
    style: inputStyle
  }, showInput ? inlineInput : inlineDisplay, validationError ? _react["default"].createElement("div", {
    className: "error-message",
    ref: errorMessageRef
  }, validationError) : null), _react["default"].createElement("div", {
    className: sizeClasses[size],
    ref: valueSizeRef,
    style: sizeStyle
  }, displayValue), _react["default"].createElement("div", {
    className: sizeClasses[size],
    ref: placeholderSizeRef,
    style: sizeStyle
  }, placeholder || ''));
};

InlineEdit.propTypes = {
  disabled: _propTypes["default"].bool,
  forwardedRef: _propTypes["default"].oneOf([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })]),
  id: _propTypes["default"].string,
  label: _propTypes["default"].node,
  minWidth: _propTypes["default"].number,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  requiredWarningMessage: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['default', 'h1', 'h2', 'h3', 'h4', 'h4', 'h5', 'h6', 'small']),
  type: _propTypes["default"].oneOf(['text', 'number', 'password', 'url', 'search', 'email', 'tel', 'textarea']),
  validateInput: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onBlur: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onEditStateChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onSave: _propTypes["default"].func,
  inputType: _propTypes["default"].oneOf(['textfield, textarea'])
};

var _default = (0, _react.forwardRef)(function (props, ref) {
  return _react["default"].createElement(InlineEdit, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
});

exports["default"] = _default;